import { render, staticRenderFns } from "./SharedUserData.vue?vue&type=template&id=44c1272c&scoped=true"
import script from "./SharedUserData.vue?vue&type=script&lang=js"
export * from "./SharedUserData.vue?vue&type=script&lang=js"
import style0 from "./SharedUserData.vue?vue&type=style&index=0&id=44c1272c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c1272c",
  null
  
)

export default component.exports